import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

/**
 * DeliveryLeadsPanel — per-lead detail for a supplier delivery (lazy-loaded).
 * Unions auto-created Lead rows with the rows ZeroBounce rejected outright
 * (which never became Lead rows), via GET /supplier-deliveries/{id}/leads.
 *
 * Props:
 *   id — supplier delivery id
 *
 * Pass a `key` that changes (e.g. a refresh counter) from the parent to force
 * a remount + refetch after an action that changes lead status elsewhere,
 * such as Accept Delivery — this component only fetches once on mount.
 */
export default function DeliveryLeadsPanel({ id }) {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/supplier-deliveries/${id}/leads`)
      .then(r => setRows(r.data))
      .catch(() => setRows({ rows: [], tally: {}, total: 0 }))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ fontSize: '12px', color: '#aaa', padding: '8px 0' }}>Loading leads…</div>;
  if (!rows || rows.total === 0) return <div style={{ fontSize: '12px', color: '#aaa', padding: '8px 0' }}>No leads for this delivery yet.</div>;

  return (
    <div>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', flexWrap: 'wrap' }}>
        {Object.entries(rows.tally).map(([status, n]) => (
          <span key={status} style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: '#eaf2fb', color: '#1a6da8', fontWeight: '600' }}>
            {status}: {n}
          </span>
        ))}
      </div>
      <div style={{ maxHeight: '260px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
          <thead>
            <tr style={{ background: '#f8f9fa' }}>
              <th style={{ padding: '5px 8px', textAlign: 'left' }}>NeTRA Lead ID</th>
              <th style={{ padding: '5px 8px', textAlign: 'left' }}>Email</th>
              <th style={{ padding: '5px 8px', textAlign: 'left' }}>Status</th>
              <th style={{ padding: '5px 8px', textAlign: 'left' }}>QA Flags</th>
            </tr>
          </thead>
          <tbody>
            {rows.rows.map((r, i) => (
              <tr key={i} style={{ borderTop: '1px solid #f0f0f0' }}>
                <td style={{ padding: '4px 8px', fontFamily: 'monospace' }}>{r.lead_id || <span style={{ color: '#ccc' }}>—</span>}</td>
                <td style={{ padding: '4px 8px' }}>{r.email || '—'}</td>
                <td style={{ padding: '4px 8px' }}>{r.status}</td>
                <td style={{ padding: '4px 8px', color: '#c0392b' }}>{(r.qa_flags || []).join(' | ')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
